import { IconReplace } from '@components/icons/replace';
import { Sidebar, useSidebar } from '@components/sidebar';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useInvalidateJourneyActions, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import { showActionSidebar } from 'ui/journey-builder/action-sidebar';
import {
  ActionTypeSelector,
  OnCreateActionSelectProps,
} from 'ui/journey-builder/create-action/action-type-selector';

import { SidebarProps } from '../common';

export const useReplaceSidebar = () => useSidebar(ReplaceSidebar, { variant: 'REGULAR' });

const ReplaceSidebar = ({ shortId }: SidebarProps) => {
  const { t } = useScopedTranslate(sidebarLocale);
  const editMutation = useUpdateJourneyAction(shortId);
  const { invalidateJourneyActions } = useInvalidateJourneyActions();

  const replaceAction = async ({ actionType, values }: OnCreateActionSelectProps) => {
    const newAction = await editMutation.mutateAsync({
      action: actionType,
      ...(values && { values }),
    });
    showActionSidebar({ id: newAction.shortId, type: newAction.action });
    await invalidateJourneyActions();
  };

  return (
    <Sidebar>
      <Sidebar.SimpleHeader title={t('title')} icon={IconReplace} />
      <Sidebar.Content>
        <Stack space={4}>
          <Stack space={2}>
            <Text text={t('selectAction')} font="bold16" />
            <Text text={t('convertTo')} font="regular14" color="textSecondary" />
          </Stack>
          <ActionTypeSelector onSelect={replaceAction} />
        </Stack>
      </Sidebar.Content>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    title: 'Convert placeholder',
    selectAction: 'Select action type',
    convertTo: 'Convert placeholder to',
  },
};
